import moment from 'moment';
import queryString from 'query-string';

import { availableLanguages } from './routes/Header/Language';

export const get = (p, o) =>
  p.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o);

export const log = A => console.log(A) || A;

export const toggleElementInArray = (element, array) => {
  const index = array.indexOf(element);
  return index < 0
    ? [...array, element]
    : [...array.slice(0, index), ...array.slice(index + 1)];
};

export const formatDate = momentDate =>
  momentDate && moment(momentDate).format('YYYY-MM-DD');

export const reformatDateISOToRegular = dateString =>
  dateString
    .split('-')
    .reverse()
    .join('.');

export const normalizeBoolean = value => {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return value;
};

export const fullQueryString = dict => {
  const stringified = queryString.stringify(dict, { encode: false });
  return stringified ? '?' + stringified : '';
};

export const addFocus = event => {
  if (document.activeElement === event.target) {
    const element = event.target;
    element.style.boxShadow = '0 0 10px 2px #5e9ed6';
    element.addEventListener('focusout', () => {
      element.style.boxShadow = '';
    });
  }
};

export const chunkedMedicard = m =>
  m
    ? `${m.substring(0, 4)}\u00a0${m.substring(4, 12)}\u00a0${m.substring(12)}`
    : '';

export const routeRest = route => {
  const [...rest] = route
    .split('/')
    .filter(function(s) {
      return this.indexOf(s) < 0;
    }, availableLanguages)
    .filter(x => !!x); // eslint-disable-line no-unused-vars
  return rest.join('/');
};

export const filterEmptyProperties = object =>
  Object.entries(object).reduce(
    (filtered, [key, value]) => ({
      ...filtered,
      ...(value && { [key]: value })
    }),
    {}
  );

export const pick = (object, params) =>
  Object.entries(object).reduce(
    (picked, [key, value]) => ({
      ...picked,
      ...(params.includes(key) && { [key]: value })
    }),
    {}
  );

export const today =
  new Date().getFullYear() +
  '' +
  ('0' + (new Date().getMonth() + 1)).slice(-2) +
  '' +
  new Date().getDate();
export const maxsurvey = process.env.REACT_APP_DATE_SURVEY;
